import { useMutation } from "@tanstack/react-query";

import { axios } from "@/client/libs/axios";

export type InitPayDateType = {
  type: "momo" | "card";

  /**
   * Orthographe historique conservée.
   */
  idempotencykey: string;

  rate: string;
  couponCode?: string;
  ambassadorCode?: string;

  currency?: string;
  countryCode?: string;
  phoneNumber?: string;
};

type ConfirmedPaymentData = {
  status: number;
  id: string;
  providerId: string | null;
  providerTransactionId: string | null;
  date: string;
  intendid: string;
  intend: unknown;
};

export type CardPaymentResponse = {
  simulated?: boolean;
  requiresRedirect?: boolean;
  success?: boolean;
  transactionNumber?: string;
  redirectUrl?: string;
  link?: string;
  status?: string;
  response?: unknown;
  data?: ConfirmedPaymentData | unknown;
};

export type MomoPaymentResponse = {
  simulated?: boolean;
  requiresRedirect: boolean;
  link?: string;
  redirectUrl?: string;
  data: ConfirmedPaymentData;
};

const normalizeOptionalCode = (value?: string): string | undefined => {
  const normalized = value?.trim();

  return normalized || undefined;
};

const pay = async (data: InitPayDateType) => {
  const body = {
    type: data.type,
    rate: data.rate,
    currency: data.currency,
    countryCode: data.countryCode,
    phoneNumber: data.phoneNumber,

    couponCode: normalizeOptionalCode(data.couponCode),

    ambassadorCode: normalizeOptionalCode(data.ambassadorCode)?.toUpperCase(),
  };

  const config = {
    headers: {
      idempotencykey: data.idempotencykey,
    },
  };

  if (data.type === "card") {
    return axios.post<CardPaymentResponse>("/payorchestrator", body, config);
  }

  return axios.post<MomoPaymentResponse>("/payorchestrator", body, config);
};

export const usePay = () => {
  const mutation = useMutation({
    mutationFn: pay,
  });

  return {
    pay: mutation.mutateAsync,
    error: mutation.error,
    loading: mutation.isPending,
  };
};
